<template>
    <div class="login-container">
        <div class="login-form">
            <div class="card card-login">
                <div class="card-header">
                    <a href="#" class="logo-link">
                        <img src="@/assets/img/logo_jtb_wht@2x.png" alt="Logo" />
                    </a>
                    <div class="text-login">{{$t('general.system_name')}}</div>
                </div>
                <form @submit.prevent="handleSubmit">
                    <div class="card-body">
                        <div class="error-message error-login" v-if="errorMessage">
                            <div class="d-flex">
                                <div><i class="icon-warning mr-1"></i></div>
                                <div>
                                    <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                                    <p class="fs-14 text-red font600" v-html=errorMessage></p>
                                </div>
                            </div>
                        </div>

                        <div class="form-box">
                            <div class="form-group">
                                <div class="form-input">
                                    <i class="icon-left icon-user"></i>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-bind:placeholder="$t('login.user_name')"
                                        name="username"
                                        v-model="username"
                                        v-validate="'required'"
                                        :data-vv-as="$t('login.user_name')"
                                    />
                                </div>
                                <span class="error-text" v-if="errors.has('username')">{{errors.first('username')}}</span>
                            </div>
                            <div class="form-group">
                                <div class="form-input">
                                    <i class="icon-left icon-lock-red"></i>
                                    <input
                                        type="password"
                                        class="form-control"
                                        v-bind:placeholder="$t('login.password')"
                                        name="password"
                                        v-model="password"
                                        v-validate="'required'"
                                        :data-vv-as="$t('login.password')"
                                    />
                                </div>
                                <span class="error-text" v-if="errors.has('password')">{{errors.first('password')}}</span>
                            </div>
                            <details>
                                <summary>{{$t('login.place_id_show')}}</summary>
                                <div class="form-group">
                                    <div class="form-input">
                                        <i class="icon-left icon-zipcode"></i>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-bind:placeholder="$t('login.place_id')"
                                            name="placeId"
                                            v-model="placeId"
                                            v-validate="'digits:4'"
                                            :data-vv-as="$t('login.place_id')"
                                        />
                                    </div>
                                    <span class="error-text" v-if="errors.has('placeId')">{{errors.first('placeId')}}</span>
                                </div>
                            </details>

                            <div class="mt-1">
                                <button class="btn btn-login">{{$t('login.login')}}</button>
                            </div>

                            <div class="text-center mt-3">
                                <label class="checkbox-custom">
                                    <input type="checkbox" class="form-control" name="rememberMe" v-model="rememberMe" />
                                    <span class="checkmark"></span>
                                    <span class="lb-">{{$t('login.remember_me')}}</span>
                                </label>
                            </div>

                            <div class="mt-3">
                                <button class="btn btn-pink-44 w-100 ex-orange-light" @click="setChangePass(true)">
                                    {{$t('login.change_password')}}
                                </button>
                            </div>

                            <div class="mt-3 text-center">
                                パスワードが分からない場合は<br>
                                <a :href="$t('chatbot.url')" target="_blank">証憑類電子化チャットボット</a>へ
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import router from "@/router";

import Utils from "@/helpers/utils";
import { Role } from "@/helpers/role";
import { AuthService } from "@/services/common/auth.service";
import StorageService from "@/services/common/storage.service";

export default {
    name: "PcLogin",
    data () {
        return {
            username: "",
            password: "",
            placeId: "",
            rememberMe: false,
            submitted: false,
            errorMessage: "",
            clickChangePass: false
        };
    },
    created(){
        /* ログアウト後、ログイン画面でブラウザバックを2回するとMFA認証画面に遷移してしまうパターンがあるのでガード */
        addEventListener("popstate", () => {
            this.callPopStateEvent();
        })
    },
    beforeMount () {
        let token = StorageService.getToken();
        if (token) {
            const role = StorageService.getUserRole();
            if (role == Role.PwReset.id) {
                router.push("/admin/users");
            } else {
                router.push("/");
            }
        }
        let remember = JSON.parse(StorageService.getRememberMe());
        if (remember) {
            this.username = remember.username;
            this.password = remember.password;
            // this.placeId = remember.placeId;
            this.rememberMe = remember.rememberMe;
        }
    },
    mounted () {
        let isExpired = StorageService.getExpired();
        if (isExpired) {
            this.errorMessage = this.$root.$t("error.error_expired");
            StorageService.removeExpired();
            this.$toasted.clear();
        }
    },
    methods: {
        callPopStateEvent() {
            let token = StorageService.getToken();
            /* 意図しないタイミングで発火するのでガード */
            if(!token){
                router.push('/login').catch(()=>{});
            }
        },
        handleSubmit (e) {
            this.errorMessage = "";
            this.submitted = true;
            this.$validator.validate().then(valid => {
                if (valid) {
                    const { username, password, placeId, rememberMe, clickChangePass } = this;
                    AuthService.login(username, password, placeId, rememberMe, clickChangePass)
                        .then(response => {
                            if (response.data) {
                                if (response.status != 200) {
                                    let errorCode = Utils.getErrorCode(response);
                                    if (errorCode) {
                                        this.errorMessage = this.$root.$t("error.error_code_" + errorCode);
                                    }
                                } else {
                                    const data = response.data;
                                    if(!data.mfaFlag) {
                                        this.errorMessage = this.$root.$t("login.error_mfa");
                                    };
                                };
                            } else {
                                if (response.status == 400) {
                                    this.errorMessage = this.$root.$t("login.error_400");
                                }
                                if (response.status == 403) {
                                    this.errorMessage = this.$root.$t("login.error_403");
                                }
                                if (response.status == 404) {
                                    this.errorMessage = this.$root.$t("login.error_404");
                                }
                            }
                        })
                        .catch(error => {
                            this.errorMessage = this.$root.$t("login.error_400");
                        });
                }
            });
        },
        setChangePass() {
            this.clickChangePass = true;
        }
    },
    destroyed() {
      /* ログアウト後、ログイン画面でブラウザバックを2回するとMFA認証画面に遷移してしまうパターンがあるのでガード */
      removeEventListener("popstate", () => {
          this.callPopStateEvent();
      })
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/pc/Login/Login.vue